<template>
    <div
        class="modal-container"
        :class="{ visible: activeModals.length }"
        @click="dismissCurrentModal(true)"
    >
        <div
            class="modal"
            v-for="modal in modals"
            :class="{
                background: !isTopModal(modal),
                new: isNew(modal),
                narrow: modal.narrow,
                mini: modal.mini,
                fullscreen: modal.fullscreen,
                wide: modal.wide,
                fixedFooter: modal.fixedFooter,
                secondaryStyling: modal.secondaryStyling
            }"
            :style="{ zIndex: 500 + modal.uid }"
            @click.stop
        >
            <div class="inner">
                <div class="header" v-if="!modal.headless">
                    <h3
                        class="wt-md font-lgish"
                        v-if="modal.title"
                        v-html="modal.title"
                    ></h3>
                    <button
                        type="button"
                        class="circled interactive grey close-modal outline"
                        @click="cancelAction(modal)"
                        v-if="modal.canDismiss"
                    >
                        <svg-icon id="cross"></svg-icon>
                    </button>
                </div>
                <!-- /.header -->

                <div class="content">
                    <vue-simplebar
                        class="content-inner"
                        :options="{ autoHide: false }"
                    >
                        <div class="modal-content-generic" v-if="!modal.type">
                            <div
                                class="content lh-loose"
                                v-html="modal.confirmMessage"
                            ></div>

                            <div class="modal-actions">
                                <div class="action float-left">
                                    <button
                                        type="button"
                                        class="button outline-black"
                                        @click="cancelAction(modal)"
                                        v-if="modal.canDismiss"
                                    >
                                        <svg-icon id="chevronLeft"></svg-icon>
                                        <span>{{ modal.cancelLabel }}</span>
                                    </button>
                                </div>
                                <div class="action float-right">
                                    <button
                                        type="button"
                                        class="button"
                                        @click="confirmAction(modal)"
                                    >
                                        <span>{{ modal.confirmLabel }}</span>
                                        <svg-icon id="chevronRight"></svg-icon>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            :class="['cus-modal modal-content-' + modal.type]"
                            v-if="modal.type"
                        >
                            <component
                                ref="activeModals"
                                :is="modal.type"
                                :data="modal.data"
                                :key="modal.uid"
                                @cancel="cancelAction(modal, $event)"
                                @confirm="confirmAction(modal, $event)"
                            ></component>
                        </div>
                    </vue-simplebar>
                    <!-- /.content-inner -->
                </div>
                <!-- /.content -->
            </div>
        </div>
        <!-- /.modal -->
    </div>
    <!-- /.modal-container -->
</template>

<script>
import BookingSchedule from "../../modals/bookings/actions/BookingSchedule.vue";
import BookingCancel from "../../modals/bookings/actions/Cancel";
import BookingConfirm from "../../modals/bookings/actions/Confirm";
import BookingDecline from "../../modals/bookings/actions/Decline";
import BookingFeedback from "../../modals/bookings/actions/Feedback";
import HirerQuoteConfirm
  from "../../modals/bookings/actions/HirerQuoteConfirm.vue";
import HirerQuotePay from "../../modals/bookings/actions/HirerQuotePay.vue";
import HirerViewQuote from "../../modals/bookings/actions/HirerViewQuote.vue";
import ListerQuote from "../../modals/bookings/actions/ListerQuote";
import ListerQuoteConfirm
  from "../../modals/bookings/actions/ListerQuoteConfirm";
import BookingPlaceOnHold from "../../modals/bookings/actions/PlaceOnHold";
import BookingQuoteReview from "../../modals/bookings/actions/QuoteReview";
import BookingResume from "../../modals/bookings/actions/Resume";
import BookingScheduleUnavailable
  from "../../modals/bookings/actions/ScheduleUnavailable";
import BookingAdd from "../../modals/bookings/Add";
import BookingAddCard from "../../modals/bookings/AddCard";
import BookingConfirmAdd from "../../modals/bookings/ConfirmAdd";
import BookingConfirmApproval from "../../modals/bookings/ConfirmApproval";
import BookingDailyList from "../../modals/bookings/DailyList";
import BookingShare from "../../modals/bookings/Share.vue";
import BriefAdd from "../../modals/briefs/Add";
import BriefConfirm from "../../modals/briefs/ConfirmAdd";
import BriefAddMOnday from "../../modals/briefs/Monday";
import BriefShare from "../../modals/briefs/Share.vue";
import ByronConfirm from "../../modals/byron/Confirm";
import ByronEnquire from "../../modals/byron/Enquire";
import ContactUsMonday from "../../modals/contact/ContactUsMonday";
import FullscreenVideo from "../../modals/generic/FullscreenVideo";
import ListingAdd from "../../modals/listings/Add";
import ListingAdvancedFilters from "../../modals/listings/AdvancedFilters";
import ListingConfirm from "../../modals/listings/ConfirmAdd";
import FirstPaymentSetup from "../../modals/listings/FirstPaymentSetup";
import ShortlistAdd from "../../modals/shortlists/Add";
import ShortlistEdit from "../../modals/shortlists/Edit";
import ShortlistShare from "../../modals/shortlists/Share.vue";
import ShortlistViewAll from "../../modals/shortlists/ViewAll";
import SubscribeNewsletter from "../../modals/contact/SubscribeNewsletter";
import TermsGeneral from "../../modals/terms/General";
import NewTermCondition from "../../modals/terms/NewTerms";
import TermsPrivacy from "../../modals/terms/Privacy";
import SelectUserType from "../../modals/user/SelectUserType";

export default {
    components: {
        'booking-daily-list': BookingDailyList,
        "booking-add-card": BookingAddCard,
        "booking-cancel": BookingCancel,
        "booking-confirm": BookingConfirm,
        "booking-confirmation": BookingConfirmApproval,
        "booking-decline": BookingDecline,
        "booking-feedback": BookingFeedback,
        "booking-hirer-quote-view": HirerViewQuote,
        "booking-lister-quote": ListerQuote,
        "booking-place-on-hold": BookingPlaceOnHold,
        "booking-quote-review": BookingQuoteReview,
        "booking-resume": BookingResume,
        "booking-schedule-unavailable": BookingScheduleUnavailable,
        "booking-schedule": BookingSchedule,
        "booking-share": BookingShare,
        "brief-add-monday": BriefAddMOnday,
        "brief-add": BriefAdd,
        "brief-confirm": BriefConfirm,
        "brief-share": BriefShare,
        "byron-enquire-confirm": ByronConfirm,
        "byron-enquire": ByronEnquire,
        "contact-us-monday": ContactUsMonday,
        "first-payment-setup": FirstPaymentSetup,
        "fullscreen-video": FullscreenVideo,
        "hirer-quote-confirm": HirerQuoteConfirm,
        "hirer-quote-pay": HirerQuotePay,
        "lister-quote-confirm": ListerQuoteConfirm,
        "listing-add": ListingAdd,
        "listing-advanced-filters": ListingAdvancedFilters,
        "listing-book-confirm": BookingConfirmAdd,
        "listing-book": BookingAdd,
        "listing-confirm": ListingConfirm,
        "new-term-condition": NewTermCondition,
        "privacy-policy": TermsPrivacy,
        "select-user-type": SelectUserType,
        "shortlist-add": ShortlistAdd,
        "shortlist-edit": ShortlistEdit,
        "shortlist-share": ShortlistShare,
        "shortlist-view-all": ShortlistViewAll,
        "subscribe-newslstter": SubscribeNewsletter,
        "terms-general": TermsGeneral,
    },

    props: {},

    data() {
        return {
            displayed: [],
        };
    },

    computed: {
        activeModals() {
            let active = [];

            for (let modal of this.modals) {
                if (!modal.dismissing) {
                    active.push(modal);
                }
            }

            return active;
        },

        modals() {
            return this.$store.getters["modals/modals"];
        },
    },

    watch: {
        modals: {
            handler() {
                for (let modal of this.modals) {
                    if (this.isNew(modal)) {
                        setTimeout(() => {
                            this.displayed.push(modal.uid);
                        }, 25);
                    }
                }
            },
            deep: true,
        },
    },

    methods: {
        cancelAction(modal, related) {
            if (
                window.location.href.includes("#" + modal.flag) ||
                window.location.href.includes("#add-listing") ||
                window.location.href.includes("#brief-us") ||
                window.location.href.includes("#list-your-space-today") ||
                window.location.href.includes("#recce") ||
                window.location.href.includes("#booking")
            ) {
                window.history.pushState(
                    "state obj or string",
                    "url",
                    window.location.href.substring(
                        0,
                        window.location.href.indexOf("#")
                    )
                );
            }
            modal.related = typeof related !== "undefined" ? related : null;
            if (typeof modal.reject === "function") {
                modal.reject(modal);
            }
            this.$store.dispatch("modals/dismissModal", modal.uid);
        },

        confirmAction(modal, related) {
            modal.related = typeof related !== "undefined" ? related : null;
            modal.resolve(modal);
            this.$store.dispatch("modals/dismissModal", modal.uid);
        },

        dismissCurrentModal(via_mask) {
            via_mask = typeof via_mask === "undefined" ? false : via_mask;

            if (
                this.topModal() &&
                this.topModal().canDismiss &&
                (!via_mask || this.topModal().maskCanDismiss)
            ) {
                this.cancelAction(this.topModal());
            }
        },

        isNew(modal) {
            return !this.displayed.includes(modal.uid);
        },

        isTopModal(modal) {
            if (this.modals.length) {
                return this.topModal().uid === modal.uid;
            }

            return false;
        },

        topModal() {
            return this.modals[this.modals.length - 1];
        },
    },
};
</script>
